import Modal from 'bootstrap/js/dist/modal';

const setCookie = function (cname, cvalue) {
	document.cookie = cname + '=' + cvalue + ';';
};

const getCookie = function (cname) {
	const name = cname + '=';
	const decodedCookie = decodeURIComponent(document.cookie);
	const ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return false;
};

const disclaimerModal = document.getElementById('disclaimer-modal');
const disclaimerModalDownload = document.getElementById('disclaimer-modal-download');

if (disclaimerModal || disclaimerModalDownload) {
	if (disclaimerModalDownload) {
		const pageHeaderDownloadButton = document.querySelector('.page-header__download-button');
		const downloads = document.querySelectorAll('.download__wrapper');
		const acceptButton = disclaimerModalDownload.querySelector('.modal-footer__button--accept');
		const declineButton = disclaimerModalDownload.querySelector('.modal-footer__button--decline');
		const cancelButton = disclaimerModalDownload.querySelector('.disclaimer-modal__cancel');

		if (pageHeaderDownloadButton || downloads.length > 0) {
			const disclaimerModalDownloadInstance = new Modal(disclaimerModalDownload, {
				backdrop: 'true',
				keyboard: false,
			});

			let currentHiddenDownload = null;

			if (pageHeaderDownloadButton) {
				const pageHeaderHiddenDownload = document.getElementById('hiddenDownload');

				pageHeaderDownloadButton.addEventListener('click', function () {
					currentHiddenDownload = pageHeaderHiddenDownload;
					disclaimerModalDownloadInstance.show();
				});
			}

			if (downloads) {
				downloads.forEach(function (download) {
					const hiddenDownload = download.querySelector('.hidden-download');

					download.addEventListener('click', function () {
						currentHiddenDownload = hiddenDownload;
						disclaimerModalDownloadInstance.show();
					});
				});
			}

			acceptButton.addEventListener('click', function () {
				disclaimerModalDownloadInstance.hide();
				if (currentHiddenDownload) {
					currentHiddenDownload.click();
				}
				currentHiddenDownload = null;
			});

			declineButton.addEventListener('click', function () {
				disclaimerModalDownloadInstance.hide();
				currentHiddenDownload = null;
			});

			cancelButton.addEventListener('click', function () {
				disclaimerModalDownloadInstance.hide();
				currentHiddenDownload = null;
			});
		}
	}

	if (disclaimerModal) {
		window.addEventListener('DOMContentLoaded', function () {
			this.setTimeout(function () {
				const disclaimerModalInstance = new Modal(disclaimerModal, {
					backdrop: 'static',
					keyboard: false,
				});

				if (!getCookie('disclaimer')) {
					disclaimerModalInstance.show();
				}

				const closeButton = disclaimerModal.querySelector('[data-bs-dismiss]');

				closeButton.addEventListener('click', function () {
					disclaimerModalInstance.hide();
					setCookie('disclaimer', 'true');
				});
			}, 1000);
		});
	}

	($ => {
		$(document).on('gform_confirmation_loaded', function (event, formId) {
			if (disclaimerModal) {
				const modalFormId = disclaimerModal.dataset.formId;

				if (formId === Number(modalFormId)) {
					disclaimerModal.querySelector('.modal-form').classList.add('hide-content');
					disclaimerModal.querySelector('.modal-post').classList.remove('hide-content');
					disclaimerModal.querySelector('.modal-footer').classList.remove('hide-content');
				}
			}

			if (disclaimerModalDownload) {
				const modalFormIdDownload = disclaimerModalDownload.dataset.formId;

				if (formId === Number(modalFormIdDownload)) {
					let pass = true;

					const confirmation = document.querySelector('.gform_confirmation_message');
					if (confirmation) {
						let confirmationData = confirmation.querySelector('[data-form-confirmation]');

						if (confirmationData) {
							confirmationData = confirmationData.dataset.formConfirmation;
						}

						if (confirmationData === 'false') {
							pass = false;
						}
					}

					if (pass) {
						disclaimerModalDownload.querySelector('.modal-form').classList.add('hide-content');
						disclaimerModalDownload.querySelector('.modal-post').classList.remove('hide-content');
						disclaimerModalDownload.querySelector('.modal-footer').classList.remove('hide-content');
					}
				}
			}
		});
	})(window.jQuery);
}
